export default __webpack_public_path__ + "static/032-a6a753341bc4d70152145036cf06587c.png";